import * as React from 'react';
import {
  SanityImage as ImageComponent,
  buildSrc as sanityBuildSrc,
  buildSrcSet as sanityBuildSrcSet,
  type WrapperProps,
} from 'sanity-image';
import type { ImageSrcInputs } from '@sanity-image/url-builder';

export const baseUrl = `https://cdn.sanity.io/images/${
  process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ||
  process.env.GATSBY_SANITY_PROJECT_ID
}/${
  process.env.NEXT_PUBLIC_SANITY_DATASET || process.env.GATSBY_SANITY_DATASET
}/`;

/**
 * A wrapper around `SanityImage` that configures the `baseUrl` prop
 * automatically.
 *
 * Simple usage:
 * @example
 * ```tsx
 * <Image
 *   id={image._id}
 *   hotspot={...}
 *   crop={...}
 *   width={450} // anticipated display width of the image
 *   alt="Some alt text. Can be dynamic/computed."
 * />
 * ```
 */
export const SanityImage = <T extends React.ElementType = 'img'>(
  props: WrapperProps<T>
) => <ImageComponent baseUrl={baseUrl} {...props} />;

export const buildSrc = (props: Omit<ImageSrcInputs, 'baseUrl'>) =>
  sanityBuildSrc({
    baseUrl,
    ...props,
  });

export const buildSrcSet = (props: Omit<ImageSrcInputs, 'baseUrl'>) =>
  sanityBuildSrcSet({
    baseUrl,
    ...props,
  });
